"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("stremio/common/Button"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var Option_1 = __importDefault(require("./Option"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Dropdown_less_1 = __importDefault(require("./Dropdown.less"));
var Dropdown = function (_a) {
    var _b;
    var level = _a.level, setLevel = _a.setLevel, options = _a.options, onSelect = _a.onSelect, selectedOption = _a.selectedOption, menuOpen = _a.menuOpen;
    var t = (0, react_i18next_1.useTranslation)().t;
    var onBackButtonClick = function () {
        setLevel(level - 1);
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(Dropdown_less_1.default['dropdown'], (_b = {}, _b[Dropdown_less_1.default['open']] = menuOpen, _b)), role: 'listbox' },
        level > 0 ?
            react_1.default.createElement(Button_1.default, { className: Dropdown_less_1.default['back-button'], onClick: onBackButtonClick },
                react_1.default.createElement(react_2.default, { name: 'caret-left', className: Dropdown_less_1.default['back-button-icon'] }),
                t('BACK'))
            : null,
        options
            .filter(function (option) { return !option.hidden; })
            .map(function (option, index) { return (react_1.default.createElement(Option_1.default, { key: index, option: option, onSelect: onSelect, selectedOption: selectedOption })); })));
};
exports.default = Dropdown;
